module.exports = __webpack_public_path__ + "static/media/MightyBuildings-Light.110852e3.webp";